import { Box, Button, Card, DataList, Text } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { FaArrowRight } from 'react-icons/fa';

import { CompanyPublic } from '@/client';

export function CompanyCard({ company }: { company: CompanyPublic }) {
  const navigate = useNavigate();

  return (
    <Card.Root
      width="md"
      variant="elevated"
      onClick={() => navigate({ to: `/${company.slug}/indicators` })}
      cursor="pointer"
      key={company.id}
    >
      <Card.Body gap="2">
        <Card.Title mb="2">{company.name}</Card.Title>
        <Card.Description as="div">
          <DataList.Root orientation="horizontal" divideY="1px">
            <DataList.Item>
              <DataList.ItemLabel>Identifiant unique</DataList.ItemLabel>
              <DataList.ItemValue>{company.slug}</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item pt="4">
              <DataList.ItemLabel>Entités</DataList.ItemLabel>
              <DataList.ItemValue>{company.entities.length}</DataList.ItemValue>
            </DataList.Item>
            <DataList.Item pt="4">
              <DataList.ItemLabel>Nombre d'indicateurs</DataList.ItemLabel>
              <DataList.ItemValue>
                <Text>{company.indicators_count}</Text>
              </DataList.ItemValue>
            </DataList.Item>
            <DataList.Item pt="4">
              <DataList.ItemLabel>Nombre d'actions</DataList.ItemLabel>
              <DataList.ItemValue>
                <Text>{company.actions_count}</Text>
              </DataList.ItemValue>
            </DataList.Item>
          </DataList.Root>
        </Card.Description>
      </Card.Body>
      <Card.Footer>
        <Box fontSize="sm" color="gray.500">
          Créé le {new Date(company.created_at || '').toLocaleDateString()}
        </Box>
        <Button ml="auto">
          View <FaArrowRight />
        </Button>
      </Card.Footer>
    </Card.Root>
  );
}
